// extracted by mini-css-extract-plugin
export default {"hideTooltip":"U8-z","fadeIn":"V8-z","delay":"W8-z","recommendedSizeTooltip":"X8-z"};